<template>
  <div class="detail-wrapper">
    <!-- 详情内容 -->
    <div class="detail-content">
      <!-- 基本信息 -->
      <div class="detail-card" v-if="detail">
        <div class="card-header">
          <div class="header-title">预约基本信息</div>
        </div>
        
        <div class="info-list">
          <div class="info-item">
            <div class="info-label">预约编号</div>
            <div class="info-value">{{detail.appointmentNo}}</div>
          </div>
          
          <div class="info-item">
            <div class="info-label">司机姓名</div>
            <div class="info-value">{{detail.driverName}}</div>
          </div>
          
          <div class="info-item">
            <div class="info-label">司机联系方式</div>
            <div class="info-value">{{detail.drivePhone}}</div>
          </div>
          
          <div class="info-item">
            <div class="info-label">车头号</div>
            <div class="info-value">{{detail.headstock}}</div>
          </div>
          
          <div class="info-item">
            <div class="info-label">车挂号</div>
            <div class="info-value">{{detail.handnum}}</div>
          </div>
          
          <div class="info-item">
            <div class="info-label">上一载地点</div>
            <div class="info-value">{{detail.previousLoc}}</div>
          </div>
          
          <div class="info-item">
            <div class="info-label">下一载地点</div>
            <div class="info-value">{{detail.nextLoc}}</div>
          </div>
          
          <div class="info-item">
            <div class="info-label">上一载品种</div>
            <div class="info-value">{{detail.variety}}</div>
          </div>
          
          <div class="info-item">
            <div class="info-label">下一载品种</div>
            <div class="info-value">{{detail.nextVariety}}</div>
          </div>
          
          <div class="info-item" v-if="detail.cargoHoldsNumbs">
            <div class="info-label">隔舱数量</div>
            <div class="info-value">{{detail.cargoHoldsNumbs}}</div>
          </div>
          
          <div class="info-item">
            <div class="info-label">罐体材质</div>
            <div class="info-value">{{detail.tankMaterial}}</div>
          </div>
          
          <div class="info-item">
            <div class="info-label">有溢油探头</div>
            <div class="info-value">{{ detail.isOilSpillProbe == 'Y' ? '是' : '否' }}</div>
          </div>

          <div class="info-item">
            <div class="info-label">预约项目</div>
            <div class="info-value">{{ detail.steamChargeitemTitle }}</div>
          </div>

          <!-- <div class="info-item">
            <div class="info-label">蒸洗口</div>
            <div class="info-value">{{detail.steamPort}}</div>
          </div> -->
          
          <div class="info-item">
            <div class="info-label">预约日期</div>
            <div class="info-value">{{detail.appointmentTime}}</div>
          </div>
          
          <div class="info-item">
            <div class="info-label">预约时间</div>
            <div class="info-value">{{detail.appointmentPdxx}}</div>
          </div>
          
          <div class="info-item" v-if="detail.payMethod == '1'">
            <div class="info-label">支付方式</div>
            <div class="info-value">公司统一支付</div>
          </div>
          
          <div class="info-item" v-if="detail.payMethod == '2'">
            <div class="info-label">支付方式</div>
            <div class="info-value">个人支付</div>
          </div>
          
          <div class="info-item">
            <div class="info-label">预约状态</div>
            <div class="info-value">
              <van-tag :type="detail.bpmStatusType" size="medium">{{detail.bpmStatusTitle}}</van-tag>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 磅单信息 -->
      <div class="detail-card" v-if="detail && detail.poundListUrl">
        <div class="card-header">
          <div class="header-title">上一载货磅单</div>
        </div>
        
        <div class="image-container">
          <van-image :src="detail.poundListUrl" fit="contain" class="detail-image" />
        </div>
      </div>
      
      <!-- 预约二维码 -->
      <div class="detail-card qrcode-card">
        <div class="card-header">
          <div class="header-title">预约二维码</div>
        </div>
        
        <div id="qrcode" class="qrcode-container"></div>

      </div>

    </div>

    <Tabbar></Tabbar>
  </div>
</template>
<script>
import Tabbar from "@/views/Public/tabbarTpl.vue";
import steamApi from "@/fetch/steamApi.js";
import QRCode from 'qrcodejs2-fix'
export default {
  components: {
    Tabbar,
  },
  inject: ['reload'],
  data()
  {
    return {
      detail:null,
      showAdjustBtn:false,
    }
  },
  created()
  {
    document.title = "蒸洗预约详情";
    var id = this.$route.params.id;
    this.$data.id = id;
    this.getSteamAppointmentDetail(id);
  },
  methods:{
    qrcode(yybh) {
      if(yybh)
      {
        
        document.getElementById('qrcode').textContent = '';
        new QRCode('qrcode', {
          text: yybh // 二维码内容
        })
      }
    },
    getSteamAppointmentDetail(id)
    {
      var that = this;
      var weburl = that.GLOBAL.weburl;
      var formData = new FormData();
      formData.append("id",id);
      steamApi.getSteamAppointmentDetail(formData).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == "0") {
          var detail = res.data;
          if(detail)
          {
            detail.poundListUrl = detail.poundListUrl ? weburl + '/' + detail.poundListUrl : "";
            switch (detail.bpmStatus) {
              case "1":
                detail.bpmStatusType = 'default';
                detail.bpmStatusTitle = '未提交';
              break;
              case "2":
                detail.bpmStatusType = 'danger';
                detail.bpmStatusTitle = '待支付';
              break;
              case "4":
                detail.bpmStatusType = 'warning';
                detail.bpmStatusTitle = '市场部待审核';
              break;
              case "5":
                detail.bpmStatusType = 'danger';
                detail.bpmStatusTitle = '市场部审核失败';
              break;
              case "7":
                detail.bpmStatusType = 'warning';
                detail.bpmStatusTitle = '洗车人员待审核';
              break;
              case "8":
                detail.bpmStatusType = 'danger';
                detail.bpmStatusTitle = '洗车人员审核失败';
              break;
              case "10":
                detail.bpmStatusType = 'warning';
                detail.bpmStatusTitle = '待作业';
              break;
              case "11":
                detail.bpmStatusType = 'warning';
                detail.bpmStatusTitle = '作业中';
              break;
              case "12":
                detail.bpmStatusType = 'success';
                detail.bpmStatusTitle = '作业完成';
              break;
              case "101":
                detail.bpmStatusType = 'danger';
                detail.bpmStatusTitle = '取消预约未退款';
              break;
              case "102":
                detail.bpmStatusType = 'default';
                detail.bpmStatusTitle = '取消预约成功';
              break;
              case "103":
                detail.bpmStatusType = 'default';
                detail.bpmStatusTitle = '审核失败未退款';
              break;
              case "104":
                detail.bpmStatusType = 'default';
                detail.bpmStatusTitle = '审核失败退款成功';
              break;
              case "105":
                detail.bpmStatusType = 'default';
                detail.bpmStatusTitle = '取消预约成功';
              break;
              case "106":
                detail.bpmStatusType = 'default';
                detail.bpmStatusTitle = '审核失败';
                break;
              case "107":
                detail.bpmStatusType = 'warning';
                detail.bpmStatusTitle = '退款中';
                break;
              case "108":
                detail.bpmStatusType = 'default';
                detail.bpmStatusTitle = '业务退款';
                break;
            }

            switch (detail.compartmentCount) {
                case "01":
                  detail.cangshiTitle = "单舱";
                  break;
                case "02":
                  detail.cangshiTitle = "双舱";
                  break;
                case "03":
                  detail.cangshiTitle = "三舱";
                  break;
                  default:
                  detail.cangshiTitle = "";
              }

            var bpmStatusInt = parseInt(detail.bpmStatus);
            that.showAdjustBtn = (bpmStatusInt<11)?true:false;
            
            if(detail.appointmentNo) that.qrcode(detail.appointmentNo);
          }

          that.detail = detail;
        }
      }).catch(function(err) {
        console.log(err);
      });
    },
   
  }
}
</script>
<style lang="scss" scoped>
.detail-wrapper {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-bottom: 60px;
}

.detail-content {
  padding: 12px;
}

.detail-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  
  .card-header {
    padding: 12px 16px;
    border-bottom: 1px solid #f5f6f7;
    
    .header-title {
      font-size: 16px;
      font-weight: 600;
      color: #323233;
      position: relative;
      padding-left: 10px;
      
      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 16px;
        background-color: #4080ff;
        border-radius: 2px;
      }
    }
  }
  
  .info-list {
    padding: 12px 16px;
  }
  
  .info-item {
    display: flex;
    padding: 8px 0;
    border-bottom: 1px solid #f5f6f7;
    
    &:last-child {
      border-bottom: none;
    }
    
    .info-label {
      width: 100px;
      font-size: 14px;
      color: #969799;
    }
    
    .info-value {
      flex: 1;
      font-size: 14px;
      color: #323233;
      font-weight: 500;
    }
  }
  
  .image-container {
    padding: 12px;
    
    .detail-image {
      width: 100%;
      min-height: 200px;
      max-height: 300px;
      border-radius: 8px;
      overflow: hidden;
    }
  }
}

.qrcode-card {
  .qrcode-container {
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 80px;
    
    img {
      width: 200px !important;
      height: 200px !important;
    }
  }
}

.footer-actions {
  position: fixed;
  bottom: 60px;
  left: 0;
  right: 0;
  display: flex;
  padding: 10px 12px;
  background-color: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 10;
  
  .action-btn {
    flex: 1;
    margin: 0 6px;
    height: 44px;
    border-radius: 8px;
    
    &.advance-btn {
      background-color: #4080ff;
      border: none;
    }
    
    &.delay-btn {
      background-color: #ff9d00;
      border: none;
    }
  }
}
</style>
<style lang="css" scoped>
.qrcode-container >>> img {
    width: 50vw;
    height: 50vw;
}
.qrcode-container >>> canvas {
  width: 50vw !important;
  height: 50vw !important;
}
</style>
